import React from 'react';

import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import theme from 'constants/theme';

import ActivityGraphTooltip from './common/ActivityGraphTooltip';

const CompetencyActivityGraph = ({
  data = [],
  competencyId,
  margin = { top: 10, right: 20, left: 10, bottom: 10 },
  levelUpProgressStatuses = [],
}) => {
  const colorAreaChartId = `colorAreaChart-${competencyId}`;
  return (
    <ResponsiveContainer>
      <AreaChart data={data} margin={margin}>
        <defs>
          <linearGradient id={colorAreaChartId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={theme.palette.green.main} stopOpacity={0.8} />
            <stop offset="95%" stopColor={theme.palette.green.main} stopOpacity={0.3} />
          </linearGradient>
        </defs>
        <XAxis
          width={2}
          stroke="lightgrey"
          tick={false}
          dataKey="createdTS"
          // type="number"
          // domain={['dataMin', 'dataMax']}
        />
        <YAxis dataKey="progressPercentage" width={2} stroke="lightgrey" tick={false} />
        <Tooltip
          allowEscapeViewBox
          content={(props) => ActivityGraphTooltip({ ...props, levelUpProgressStatuses })}
          wrapperStyle={{ pointerEvents: 'all', maxWidth: '80%' }}
        />
        <Area
          dot={{ r: 3 }}
          activeDot={{ r: 5 }}
          isAnimationActive={false}
          name="Activity"
          type="monotone"
          dataKey="progressPercentage"
          stroke={`url(#${colorAreaChartId})`}
          connectNulls
          fill={`url(#${colorAreaChartId})`}
          // onMouseEnter={item => console.log({ item })}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default CompetencyActivityGraph;
